import { Office } from './office';
import { Administrator } from './administrator';
import { Product } from './product';
import { CreditStatus, CreditStatusNames } from './credit-status';
import { Client } from './client';
import { PaymentMethod } from './payment-method';
import { BankAccount } from './bank-account';
import { CollectorOperator, Collector } from './collector';
import { Reminder } from './reminder';
import { Tag } from './tag';
import { PaymentPromise } from './payment-promise';
import moment from 'moment';
import { Partner } from './partner';
import { Currency } from './currency';

export const ENFORCEMENT_CASES_FORFEIT_START = moment('2024-12-12 00:00'); // TODO: get from credits?
/**
 * TODO: DELETE
 *  Used to detect ENFORCEMENT_CASES from installment.credit.id
 * /admin/credits/{creditId}/installments has credit identity view;
 * added to avoid temporary changes in credits
 * */
export const FIRST_ENFORCEMENT_CASES_FORFEIT_CREDIT_ID = 747205;
export const ENFORCEMENT_CASES_FORFEIT_START_GC = moment('2024-12-19 00:00'); // TODO: get from credits?

export class CreditBase {
  contractTime?: string;
  createTime?: string;
  confirmationTime?: string;
  dueDate?: string;
  repaymentDate?: string;
  creditStatus?: CreditStatus;
  dailyInterest?: number;
  discountCode?: string;
  fullRateAccruals?: boolean;
  id?: number;
  installmentAmount?: number;
  installmentDays?: number;
  installmentForfeit?: number;
  forfeitDiscount?: number;
  installmentsNumber?: number;
  office?: Office;
  operator?: Administrator;
  paymentMethod?: PaymentMethod;
  principal?: number;
  product?: Product;
  refinanceEnabled?: boolean;
  installmentUtilizationFee?: number;
  utilizationFee?: boolean;
  user?: Client;
  utilizationTime?: string;
  preferredPaymentMethod?: PaymentMethod;
  preferredBankAccount?: BankAccount;
  tags?: Tag[];
  forfeitEnabled?: boolean;
  penaltyEnabled?: boolean;
  interestEnabled?: boolean;
  utilizationFeeEnabled?: boolean;
  overdueInterestEnabled?: boolean;
  accruedOverdueInterest?: number;
  // max sum of all accruals; null - no cap
  lifetimeCostCap?: number;
  lifetimeCostCapReached?: boolean;
}

export class Credit extends CreditBase {
  firstInstallmentDate?: Date;
  maturedUnpaid?: number;
  active?: boolean;
  partner?: Partner;
  currency?: Currency;

  constructor(partial: Partial<Credit>) {
    super();
    Object.assign(this, partial);
  }
}

export interface SerializedCredit extends CreditBase {
  firstInstallmentDate?: string;
}

export interface CollectorCredit extends Credit {
  collectorOperator?: CollectorOperator;
  collector?: Collector;
  credit?: RequestCreditView;
  paymentPromise?: PaymentPromise;
}
export interface RequestCreditView extends Credit {
  selectedReminder: Reminder;
  reminders: Reminder[];
}

export interface CreditSearchResult {
  id: number;
  userId: number;
  creditStatusName: string;
  userFullName: string;
  userCivilId: string;
  userMobile: string;
  userEmail: string;
  productName: string;
  userBrandName: string;
}

export interface CollectionCredit {
  id?: number;
  active?: number;
  refreshedAt?: string;
  overdueDays?: number;
  principal?: number;
  contractTime?: string;
  operatorId?: number;
  brandId?: number;
  productId?: number;
  clientId?: number;
  clientFullName?: string;
  clientCivilId?: string;
  clientEmail?: string;
  clientMobile?: string;
}

export interface PayinCreditMatch {
  bankAccounts?: string[];
  brandId?: number;
  brandName?: string;
  clientCivilId?: string;
  clientId?: number;
  clientName?: string;
  collectionCategory?: any;
  hasOtherActiveCredits?: boolean;
  id?: number;
  maturedUnpaid?: number;
  principal?: number;
  productId?: number;
  productName?: string;
  totalUnpaid?: number;
}
export interface PayinCreditMatchDTO {
  brandCode: string;
  creditId: string;
  civilId: string;
  iban: string;
  firstName: string;
  middleName: string;
  lastName: string;
  limit?: number;
  includeCollectionAssignment?: boolean;
  includeClientBankAccounts?: boolean;
  includeNextInstallment?: boolean;
  creditStatusFilter?: Array<CreditStatusNames>
}

export interface PbxCredit extends Credit {
  isUnrelated?: boolean;
}
